import { RouteRecordRaw, RouterView } from "vue-router";
import { h } from "vue";

const delaysRoutes: RouteRecordRaw = {
  path: "/delays",
  component: () => import("../layouts/SimpleLayout.vue"),
  children: [
    {
      path: "",
      name: "delaysRoot",
      component: { render: () => h(RouterView) },
      redirect: { name: "delays" },
      meta: { breadcrumb: "delays" },
      children: [
        {
          path: "",
          name: "delays",
          component: () => import("../views/DelaysView.vue"),
        },
        {
          path: ":uuid",
          name: "delayDetails",
          component: () => import("../views/DelayDetailsView.vue"),
          meta: {
            breadcrumb: "delays_details",
          },
        },
        {
          path: ":uuid/sign",
          name: "delaySign",
          component: () => import("../views/DelaySignView.vue"),
          meta: {
            breadcrumb: "delays_sign",
          },
        },
        {
          path: "data",
          name: "delaysData",
          component: () => import("../views/DelaysDataView.vue"),
          meta: {
            breadcrumb: "delay_data",
          },
        },
      ],
    },
  ],
};

export default delaysRoutes;
